<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>

          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="getStepForPercentComplete()"
                                      [totalSteps]="wizard.totalSteps"></app-complete-bar>
                    <h2 [innerHtml]="'ContactInformation' | translator: 'base'">Your PSP Record</h2>
                    <div class="justify-content-md-center form-group form-inline">
                         <p class="step-text"
                            [innerHtml]="'NameAndDob' | translator: 'base'">
                              Let's start with your name and date of birth.
                         </p>
                         <div class="row gx-2">
                              <div class="col col-12 col-md-7 pe-md-2 mb-3"
                                   [formGroup]="form">
                                   <label for="firstName"
                                          class="form-label">
                                        <span [innerHtml]="'FirstName' | translator: 'base'">
                                             First Name
                                        </span>
                                        <span class="text-danger text-center ms-1"
                                              [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input formControlName="firstName"
                                          [title]="'FirstName' | translator: 'base'"
                                          class="bg-light form-control"
                                          type="text"
                                          id="driverFirstName"
                                          name="driverFirstName"
                                          required
                                          maxLength="30" />
                                   <span *ngIf="firstName!.invalid && firstName!.dirty"
                                         class="help-block text-danger">
                                        <span *ngIf="firstName!.errors?.['required']"
                                              [innerHtml]="'UserFirstName_required' | translator: 'base'">
                                             First name is required.
                                        </span>

                                        <span *ngIf="firstName!.errors?.['pattern']"
                                              [innerHtml]="'FirstName_invalid' | translator: 'base'">
                                             First name contains invalid value(s). Please use only letters, apostrophes
                                             and
                                             spaces.
                                        </span>
                                        <span *ngIf="firstName!.errors?.['maxlength']"
                                              [innerHtml]="'DriverFirstName_max' | translator: 'base'">
                                             First Name must be 30 characters or less.
                                        </span>
                                   </span>
                              </div>
                              <div class="col col-12 col-md-5 ps-md-2 mb-3"
                                   [formGroup]="form">
                                   <label for="middleInitial"
                                          class="form-label"
                                          [innerHtml]="'MiddleInitial' | translator: 'base'">
                                        Middle Initial
                                   </label>
                                   <input formControlName="middleInitial"
                                          [title]="'MiddleInitial' | translator: 'base'"
                                          class="bg-light form-control"
                                          type="text"
                                          id="driverMiddleInitial"
                                          name="driverMiddleInitial"
                                          maxLength="10" />
                                   <span *ngIf="middleInitial!.invalid && middleInitial!.dirty"
                                         class="help-block text-danger">
                                        <span *ngIf="middleInitial!.errors?.['pattern']"
                                              [innerHtml]="'AlphaOnly' | translator: 'base'">
                                             Please use letters only.
                                        </span>
                                        <span *ngIf="middleInitial!.errors?.['maxlength']"
                                              [innerHtml]="'DriverMI_max' | translator: 'base'">
                                             Middle initial must be 10 characters or less.
                                        </span>
                                   </span>
                              </div>
                         </div>
                         <div class="row gx-2">
                              <div class="col col-12 col-md-7 pe-md-2 mb-3"
                                   [formGroup]="form">
                                   <label for="lastName"
                                          class="form-label">
                                        <span [innerHtml]="'LastName' | translator: 'base'">Last Name</span>
                                        <span class="text-danger text-center ms-1"
                                              [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input formControlName="lastName"
                                          [title]="'LastName' | translator: 'base'"
                                          class="bg-light form-control"
                                          type="text"
                                          id="drvierLastName"
                                          name="driverLastName"
                                          required
                                          maxLength="30" />
                                   <span *ngIf="lastName!.invalid && lastName!.dirty"
                                         class="help-block text-danger">
                                        <span *ngIf="lastName!.errors?.['required']"
                                              [innerHtml]="'UserLastName_required' | translator: 'base'">
                                             Last name is required.
                                        </span>
                                        <span *ngIf="lastName!.errors?.['pattern']"
                                              [innerHtml]="'LastName_invalid' | translator: 'base'">
                                             Last name contains invalid value(s). Please use only letters, apostrophes
                                             and
                                             spaces.
                                        </span>
                                        <span *ngIf="lastName!.errors?.['maxlength']"
                                              [innerHtml]="'DriverLastName_max' | translator: 'base'">
                                             Last name must be 30 characters or less.
                                        </span>
                                   </span>
                              </div>
                              <div class="col col-12 col-md-5 ps-md-2 mb-3"
                                   [formGroup]="form">
                                   <label for="suffix"
                                          class="form-label"
                                          [innerHtml]="'Suffix' | translator: 'base'">
                                        Suffix
                                   </label>
                                   <input formControlName="suffix"
                                          [title]="'Suffix' | translator: 'base'"
                                          class="bg-light form-control"
                                          type="text"
                                          id="suffix"
                                          name="suffix"
                                          maxlength="10" />
                                   <span class="help-block text-danger"
                                         *ngIf="suffix!.errors?.['pattern']"
                                         [innerHtml]="'AlphaOnly' | translator: 'base'">
                                        Please use letters only.
                                   </span>
                                   <span class="help-block text-danger"
                                         *ngIf="suffix!.errors?.['maxlength']"
                                         [innerHtml]="'DriverSuffix_max' | translator: 'base'">
                                        Middle initial must be 10 characters or less.
                                   </span>
                              </div>
                         </div>
                         <div class="row">
                              <div class="col-12">
                                   <div class="form-group"
                                        [formGroup]="form">
                                        <label for="driverDateOfBirth"
                                               class="form-label text-nowrap">
                                             <span [innerHtml]="'DOB' | translator: 'base'">Date ofBirth</span>
                                             <span class="text-danger text-center ms-1"
                                                   [title]="'Required' | translator: 'base'">*</span>
                                        </label>
                                        <input formControlName="dateOfBirth"
                                               [title]="'DOB' | translator: 'base'"
                                               class="bg-light form-control"
                                               type="text"
                                               placeholder="12/31/1989"
                                               mask="00/00/0000"
                                               id="driverDateOfBirth"
                                               name="driverDateOfBirth"
                                               (keyup)="dateOfBirthChanged()"
                                               required
                                               maxlength="10" />
                                        <span *ngIf="dateOfBirth!.dirty"
                                              class="help-block text-danger">
                                             <span *ngIf="hasStandardDOBError"
                                                   class="text-center"
                                                   [innerHtml]="'StandardDOBError' | translator: 'base'">
                                                  * Required. Format must be 12/31/1989.
                                             </span>
                                             <span *ngIf="hasInvalidDOBError"
                                                   class="text-center"
                                                   [innerHtml]="'InvalidDOBError' | translator: 'base'">
                                                  Enter a valid date.
                                             </span>
                                             <span *ngIf="isTooYoungError"
                                                   class="text-center"
                                                   [innerHtml]="'TooYoungError' | translator: 'base'">
                                                  You must be 18-years-old.
                                             </span>
                                        </span>
                                   </div>
                              </div>
                         </div>

                         <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                              <div class="btn-group"
                                   role="group">
                                   <button [routerLink]="wizard.continueLinkRoute(_step)"
                                           (click)="scrollToTop()"
                                           class="btn btn-primary btn-strong"
                                           [title]="'Continue' | translator: 'base'"
                                           [disabled]="form.status === 'INVALID' || hasStandardDOBError || hasInvalidDOBError || isTooYoungError"
                                           name="driverNext"
                                           id="driverNext">
                                        <span [innerHtml]="'Continue' | translator: 'base'">Continue</span>
                                   </button>
                              </div>

                              <div class="btn-group"
                                   role="group">
                                   <button [routerLink]="wizard.backLinkRoute(_step)"
                                           (click)="scrollToTop()"
                                           class="btn btn-outline-primary"
                                           [title]="'Back' | translator: 'base'"
                                           [innerHtml]="'Back' | translator: 'base'"
                                           name="driverBack"
                                           id="driverBack">
                                        Back
                                   </button>
                                   <button [routerLink]="wizard._cancelLinkRoute"
                                           tag="button"
                                           class="btn btn-light"
                                           (click)="scrollToTop()"
                                           name="driverCancel"
                                           id="driverCancel"
                                           [innerHtml]="'Cancel' | translator: 'base'"
                                           [title]="'Cancel' | translator: 'base'">
                                        Cancel
                                   </button>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="wizard.visualProgressStep(_step)" 
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>